import Model, { ID, Integer, MODEL_LEVEL } from 'src/models/model'

export default class TitleClass extends Model {
  static name = 'TitleClass'

  static isConfiguration = true

  static deletable = true

  static versioned = true

  static level = MODEL_LEVEL.CIRCUIT

  static employeeRequiredPermissionCategories = [Model.permissionCategories.FilmProgramming]

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true
      },
      name: {
        type: String,
        required: true,
        translatable: true
      },
      description: {
        type: String,
        required: false
      },
      color: {
        type: String,
        required: false
      },
      displayOrder: {
        type: Integer,
        default: 100
      }
    }

    this.fragments = {
      select: ['id', 'name', 'color']
    }
  }
}
